module.exports = __webpack_public_path__ + "static/media/7@960w.142d4301.jpg";